module.exports = __webpack_public_path__ + "img/estagio-cover.d7b9199b.jpg";